import React from 'react';
import { OrgComponentProps } from '../../typescriptHelpers';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import Table from 'antd/lib/table';
import { useSelector } from 'react-redux';
import { selectOrg } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import { antGrey } from '../styles/globalStyles';
import { DirectorySyncGroup, UserGroupsForDirectoySyncGroup } from '../../types';
import Text from 'antd/lib/typography/Text';
import { SettingOutlined } from '@ant-design/icons';
import { ColumnType } from 'antd/lib/table';
import { displayTextForUserGroupSingular } from '../../helpers/displayHelpers';
import { EditGroupsForDirectorySyncGroupModal } from './EditGroupsForDirectorySyncGroupModal';

export const DirectorySyncUserGroupsForGroups: React.FC<OrgComponentProps> = (props: OrgComponentProps) => {
    const groupsToUserGroups = useSelector((state: RootState) => {
        const org = selectOrg(state, props.orgId);
        const directorySyncUserGroupIdsForGroups = org.ssoSamlConfig.directorySyncUserGroupsForGroups || [];
        return directorySyncUserGroupIdsForGroups.map((directorySyncUserGroupIdsForGroup) => {
            return {
                group: directorySyncUserGroupIdsForGroup.group,
                userGroups: directorySyncUserGroupIdsForGroup.userGroups.map(
                    (groupId) => org.orgSettings.groups[groupId],
                ),
            };
        });
    });

    const [selectedRow, setSelectedRow] = React.useState<UserGroupsForDirectoySyncGroup>(null);

    const renderColumnTitle = (title: string) => {
        return (
            <Text strong style={{ marginRight: 66 }}>
                {title}
            </Text>
        );
    };

    const renderGroup = (group: DirectorySyncGroup) => {
        return <Text>{group.name}</Text>;
    };

    const renderUserGroups = (row: UserGroupsForDirectoySyncGroup) => {
        const groupsString = row.userGroups?.map(displayTextForUserGroupSingular).join(', ') ?? '';

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flex: 1,
                }}
            >
                {!row.userGroups || row.userGroups?.length === 0 ?
                    <Text type="secondary">No user groups</Text>
                :   groupsString}
                <Space style={{ marginRight: 10, marginLeft: 20 }} size={24}>
                    <Button
                        onClick={() => {
                            setSelectedRow(row);
                        }}
                        icon={<SettingOutlined style={{ color: antGrey.grey8 }} />}
                        ghost
                    />
                </Space>
            </div>
        );
    };

    const columns: ColumnType<UserGroupsForDirectoySyncGroup>[] = [
        {
            title: renderColumnTitle(`Directory Provider Group`),
            dataIndex: 'group',
            render: renderGroup,
        },
        {
            title: renderColumnTitle('Runway user groups'),
            render: renderUserGroups,
        },
    ];

    return (
        <Space direction="vertical" size={32}>
            <Space direction="vertical" size={8}>
                <Text type="secondary">
                    Runway can automatically assign Runway user groups to users based on the Directory Sync group or
                    groups to which they belong to.
                </Text>
            </Space>
            <Table
                size="middle"
                locale={{
                    emptyText: 'No groups found',
                }}
                columns={columns}
                dataSource={groupsToUserGroups}
                pagination={{ hideOnSinglePage: true, defaultPageSize: 5, size: 'default' }}
            />
            <EditGroupsForDirectorySyncGroupModal
                open={!!selectedRow}
                row={selectedRow}
                orgId={props.orgId}
                onCancel={() => setSelectedRow(null)}
            />
        </Space>
    );
};
